/* eslint-disable no-undef */
// Cart Data
const cartData = cartItems.filter(function(item) {
  if(item.properties != null ) {
    return item.properties._bundle_type;
  }
});
const bundleImage = bundleCartImage;

// Local variables

const bundleBloodDrawType = cartData.filter(function( item ) {
  if(item.properties != null ) {
    return item.properties._bundle_type === "Blood draw in lab";
  }
});

// Check if the category testing product for enterprise customer
const hasIncludeSubItems = cartItems.filter(function(item) {
  if(item.sku.includes("SUB-INCLUDED") ) {
    return item;
  }
});


// Bunlde Cart Remove

function removeBundle(itemArray) {
  let updates = {};

  itemArray.forEach(function(item) {
    updates[item] = 0;
  });

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    window.location.reload();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Remove Individual Bundle Item

function removeIndividualBundle(id) {
  let updates = {};
  updates[id] = 0;

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      updates,
      sections: ["cart"],
      sections_url: window.location.pathname,
    })
  })
  .then( (response) => {
    return response.json();
  })
  .then(data => updateBundleCart(data))
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateItemQuantity(id, quantity) {
  const body = JSON.stringify({
    id: `${id}`,
    quantity: quantity,
    sections: ["cart"],
    sections_url: window.location.pathname,
  });

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body
  })
  .then( (response) => {
    return response.json();
  })
  .then(data => updateBundleCart(data))
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateBundleCart(data) {
  const filteredData = data.items.filter(function( item ) {
    if(item.properties != null ) {
      return item.properties._bundle_type === "Blood draw in lab";
    }
  });

  // build the UI
  createBundleBloodDrawCartUI(filteredData);

  // update sidebar Dom

  const cartTemplateHTML = new DOMParser().parseFromString(
    data.sections["cart"],
    "text/html"
  );
  if (data.items.length > 0) {
    // header cart counter update
    document.querySelector(".it-cart--bubble").innerText = data.item_count;
  } else {
    document.querySelector(".it-cart--bubble").remove();
  }

  // cart html update
//   document.querySelector(".it-cart--left").innerHTML =
//   cartTemplateHTML.querySelector(".it-cart--left").innerHTML;
  document.querySelector(".it-cart--sidebar").innerHTML =
  cartTemplateHTML.querySelector(".it-cart--sidebar").innerHTML;

  // enable functions
  removeItem();
  bundleQty();

  if (cartData.length > 0 && !customerTags.includes("hasValidSubscription")) {
    if (hasIncludeSubItems.length === 0) {
      const checkMicroModalInit = setInterval(() => {
          if(window.MicroModal != undefined) {
              clearInterval(checkMicroModalInit);
              if (!document.getElementById("exclusive-warning-modal").classList.contains("is-open")) {
                  window.MicroModal.show("bundle-cart-warning-modal");
              }
          }
      }, 100);
      document.querySelector("#it-checkout").setAttribute("disabled", "disabled");
    }
  }

  // remove loader
  document.querySelector(".it-cart").classList.remove("loader");
}

function removeItem() {

  document.querySelectorAll(".product-bundle-remove").forEach(function(button) {
    button.addEventListener("click", function(event) {
      document.querySelector(".it-cart").classList.add("loader");
      event.preventDefault();
      event.stopPropagation(); 

      const id = button.dataset.id;
      removeIndividualBundle(id);
    });
  });
}


// Bundle Item Quantity Function

function bundleQty() {
  document.querySelectorAll(".product-bundle-quantity_ctrl").forEach(function(ctrl) {
    ctrl.addEventListener("click", function() {
      document.querySelector(".it-cart").classList.add("loader");
      let currentQty = parseInt(ctrl.parentNode.querySelector("#product-bundle-quantity_number").innerText);
      const currentVariantId = parseInt(ctrl.parentNode.dataset.id);

      if( ctrl.dataset.action === "dec" ) {
        currentQty = currentQty - 1;
      } else {
        currentQty = currentQty + 1;
      }
      ctrl.parentNode.querySelector("#product-bundle-quantity_number").innerText = currentQty;
      updateItemQuantity(currentVariantId, currentQty);
    });
  });
}

// UI Generate for Blood Draw Bundle
function createBundleBloodDrawCartUI(data) {
  const listedProvince = data.map(function(d){ return d.properties.Province; });
  const listedCountry = data.map(function(d){ return d.properties.Country; });

  if ( document.getElementsByClassName("it-cart--items-bundle").length > 0 ) {
    document.querySelector(".it-cart--items-bundle").remove();
  }
  const cartHTML = `
    <div class="it-cart--item it-cart--items-bundle">
        <div class="it-cart--item-image">
            <img class="cart__image" src=${bundleImage} alt="Category Testing Bundle">
        </div>
        <div class="it-cart--item-info">
            <div class="it-cart--item-info-left">
                <h3 class="it-cart--item-info-title">Category Testing</h3>
                    <p class="it-cart--item-info-text">
                        State/Province: ${listedProvince.filter( function(value, index, self ) { return self.indexOf(value) === index; } ).map( function( province ) { return province; }).join(",")}
                    </p>
                    <p class="it-cart--item-info-text">
                        Country:${listedCountry.filter( function(value, index, self ) { return self.indexOf(value) === index; } ).map( function( country ) { return country; }).join(",")}
                    </p>
                    <cart-remove 
                        class="it-cart--item-info-button"
                        type="button"
                        data-variant-ids="[${data.map(function(d) { return d.id; })}]"
                    >Remove</cart-remove>
            </div>
            <div class="it-cart--item-info-right">
                <p class="it-cart--item-price" data-total-price="${parseFloat(data.reduce(function(total, curr){
              return total + curr.price * curr.quantity;
            }, 0) / 100).toFixed(2)}">
                    $${parseFloat(data.reduce(function(total, curr){
                    return total + curr.price * curr.quantity;
                    }, 0) / 100).toFixed(2)}
                </p>
            </div>
        </div>
        <ul class="product-bundles">
            ${
            data.map(function(d) {
                return `<li class="product-bundle product-bundle-check" data-id="${d.id}">
                <div class="product-bundle-image">
                    <img src="${d.featured_image.url}" alt="${d.product_title}" />
                    <span>${d.quantity}</span>
                </div>
                <div class="product-bundle-info">
                    <h4>${d.product_title}</h4>
                    <p>$${(d.price / 100).toFixed(2)}</p>
                </div>
                <div class="product-bundle-quantity_box" data-id="${d.id}">
                    ${d.quantity === 1 ? 
                    `<button type="button" class="product-bundle-remove" data-id="${d.id}" data-price="${d.price / 100}" data-qty="${d.quantity}" ${data.length === 1 ? `disabled` : ''}>
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.37522 20.5H16.6248L17.7987 5.59091H19V2.31818H13.5217V0.5H6.47826V2.31818H1V5.59091H2.2017L3.37522 20.5ZM15.897 19.7727H4.10304L2.98626 5.59091H17.0141L15.897 19.7727ZM1.78261 4.86364V3.04545H7.26087V1.22727H12.7391V3.04545H18.2174V4.86364H1.78261Z" fill="${data.length === 1 ? '#dadada' : '#C80000'}"/>
                        <path d="M10.3915 8.13643H9.60889V17.2273H10.3915V8.13643Z" fill="${data.length === 1 ? '#dadada' : '#C80000'}"/>
                        <path d="M14.4372 8.18943L13.658 8.12129L12.7414 17.1722L13.5205 17.2403L14.4372 8.18943Z" fill="${data.length === 1 ? '#dadada' : '#C80000'}"/>
                        <path d="M7.2246 17.1879L6.47603 8.1208L5.69569 8.17644L6.44427 17.2435L7.2246 17.1879Z" fill="${data.length === 1 ? '#dadada' : '#C80000'}"/>
                    </svg>
                    </button>` : `<button class="product-bundle-quantity_ctrl" data-action="dec">-</button>`
                    }
                    <div class="product-bundle-quantity">
                    Qty<span id="product-bundle-quantity_number">${d.quantity}</span>
                    </div>
                    <button class="product-bundle-quantity_ctrl" data-action="inc">+</button>
                </div>
                </li>`;
            }).join("")
            }
        </ul>
        <div class="it-cart--item-mobile-info">
            <cart-remove 
                class="it-cart--item-info-button"
                type="button"
                data-variant-ids="[${data.map(function(d) { return d.id; })}]"
            >Remove</cart-remove>
            <p class="it-cart--item-price" data-total-price="${parseFloat(data.reduce(function(total, curr){
            return total + curr.price * curr.quantity;
            }, 0) / 100).toFixed(2)}">
                    $${parseFloat(data.reduce(function(total, curr){
                    return total + curr.price * curr.quantity;
                    }, 0) / 100).toFixed(2)}
            </p>
        </div>
    </div>
  `;
  document.querySelector(".it-cart--form").insertAdjacentHTML("afterbegin", cartHTML);
  document.querySelector("body").classList.remove("cart-loader");
}

if ( bundleBloodDrawType.length > 0 ) {
  createBundleBloodDrawCartUI(bundleBloodDrawType);

  removeItem();
  bundleQty();
} else {
  document.querySelector("body").classList.remove("cart-loader");
}


if (cartData.length > 0 && !customerTags.includes("hasValidSubscription")) {
  if (hasIncludeSubItems.length === 0) {
    const checkMicroModalInit = setInterval(() => {
        if(window.MicroModal != undefined) {
            clearInterval(checkMicroModalInit);
            if (!document.getElementById("exclusive-warning-modal").classList.contains("is-open")) {
                window.MicroModal.show("bundle-cart-warning-modal");
            }
        }
    }, 100);
    document.querySelector("#it-checkout").setAttribute("disabled", "disabled");
  }
}

// Healthspan Addon Cart Functionality Starts here

const healthspanAddonCartData = [];

if (cartData.length > 0) {
  cartData.forEach(function(data) {
    healthspanAddonCartData.push({
      'id': data.id,
      'quantity': data.quantity,
      'properties': {
        'Country': data.properties.Country,
        'Province': data.properties.Province,
        '_bundle_type': "Blood draw in lab"
      }
    });
  });

  if(document.querySelector(".healthspan-items-add").classList.contains("hide")) {
    document.querySelector(".healthspan-items-add").classList.remove("hide");
  }
}


class HealthspanCartAddonBox extends HTMLElement {
  constructor() {
    super();

    this.querySelector("input[type='number']").addEventListener("change", this.quantityChange);
  }

  quantityChange(event) {

    const selectedVariantID = parseInt(this.closest(".healthspan-addon-box").dataset.id);

    if (parseInt(event.target.value) < 1) {
      this.closest(".healthspan-addon-box").classList.remove("selected");
      const findDeleteIndex = healthspanAddonCartData.findIndex(function(data) {
        return data.id === selectedVariantID;
      });
      if(findDeleteIndex !== -1) {
        healthspanAddonCartData.splice(findDeleteIndex, 1);
      }
    } else {
      if(!this.closest(".healthspan-addon-box").classList.contains("selected")) {
        this.closest(".healthspan-addon-box").classList.add("selected");
      }

      const itemsPropertiesItems = cartItems.filter(function(item) {
      return Object.keys(item.properties).length > 0;
      });

      const existCurrentVariant = healthspanAddonCartData.filter(function(data) {
        return data.id === selectedVariantID;
      });

      if (existCurrentVariant.length > 0) {
        healthspanAddonCartData.forEach(function(data) {
          if (data.id === selectedVariantID) {
            data.quantity = parseInt(event.target.value);
          }
        });

      } else {
        healthspanAddonCartData.push({
          'id': selectedVariantID,
          'quantity': parseInt(event.target.value),
          'properties': {
            'Country': itemsPropertiesItems[0].properties.Country,
            'Province': itemsPropertiesItems[0].properties.Province,
            '_bundle_type': "Blood draw in lab"
          }
        });
      }
    }
    
    if(healthspanAddonCartData.length > 0) {
      if(document.querySelector(".healthspan-items-add").classList.contains("hide")) {
        document.querySelector(".healthspan-items-add").classList.remove("hide");
      }
    } else {
      document.querySelector(".healthspan-items-add").classList.add("hide");
    }
  }
}

class HealthspanAddonQtyCtrlMobile extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.quantityChangeMobile);
  }

  quantityChangeMobile(event) {
    const selectedVariantID = parseInt(this.closest(".healthspan-addon-qty-mobile").dataset.id);
    let currentQty = parseInt(this.closest(".healthspan-addon-qty-mobile").querySelector(".healthspan-addon-qty-mobile_number span").innerText);

    if(this.dataset.action === "dec") {
      currentQty = currentQty - 1;
    } else {
      currentQty = currentQty + 1;
    }

    this.closest(".healthspan-addon-qty-mobile").querySelector(".healthspan-addon-qty-mobile_number span").innerText = currentQty;

    if( currentQty <= 0) {
      this.closest(".healthspan-addon-qty-mobile").querySelector(".healthspan-addon-qty-mobile_ctrl[data-action='dec']").setAttribute("disabled", "disabled");
      const findDeleteIndex = healthspanAddonCartData.findIndex(function(data) {
        return data.id === selectedVariantID;
      });
      if(findDeleteIndex !== -1) {
        healthspanAddonCartData.splice(findDeleteIndex, 1);
      }
    } else {
      this.closest(".healthspan-addon-qty-mobile").querySelector(".healthspan-addon-qty-mobile_ctrl[data-action='dec']").removeAttribute("disabled");

      const itemsPropertiesItems = cartItems.filter(function(item) {
      return Object.keys(item.properties).length > 0;
      });

      const existCurrentVariant = healthspanAddonCartData.filter(function(data) {
        return data.id === selectedVariantID;
      });

      if (existCurrentVariant.length > 0) {
        healthspanAddonCartData.forEach(function(data) {
          if (data.id === selectedVariantID) {
            data.quantity = currentQty;
          }
        });

      } else {
        healthspanAddonCartData.push({
          'id': selectedVariantID,
          'quantity': currentQty,
          'properties': {
            'Country': itemsPropertiesItems[0].properties.Country,
            'Province': itemsPropertiesItems[0].properties.Province,
            '_bundle_type': "Blood draw in lab"
          }
        });
      }
    }
    if(healthspanAddonCartData.length > 0) {
      if(document.querySelector(".healthspan-items-add").classList.contains("hide")) {
        document.querySelector(".healthspan-items-add").classList.remove("hide");
      }
    } else {
      document.querySelector(".healthspan-items-add").classList.add("hide");
    }
  }
}

class HealthspanCartItemsAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.addItems);
  }
  
  addItems(event) {
    event.target.innerText = "Adding...";

    const bundleCart = {
      'items': healthspanAddonCartData
    };

    // checking if the items already in the cart and remove

    if (cartData.length > 0) {
      let updates = {};

      cartData.forEach(function(item) {
        updates[item.id] = 0;
      })

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        // Adding Items to Cart

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(bundleCart)
        })
        .then(function() {
          window.location.reload();
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {

      // Adding Items to Cart

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bundleCart)
      })
      .then(function() {
        window.location.reload();
      })
      .catch(function(error) {
        console.error('Error:', error);
      });
    }
  }
}

customElements.define("healthspan-cart-addon-box", HealthspanCartAddonBox);
customElements.define("healthspan-cart-items-add", HealthspanCartItemsAdd);
customElements.define("healthspan-addon-qty-mobile-ctrl", HealthspanAddonQtyCtrlMobile);